$.datepicker.setDefaults($.datepicker.regional.de),
  $("#datepicker-cart").datepicker({
    beforeShowDay: unavailable,
    minDate: 1,
    maxDate: 365,
    dateFormat: "dd.mm.yy",
    firstDay: 1,
  });
var days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
const currentDate = new Date(); // Standard-Code, der LIVE sein sollte
//const currentDate = new Date("February 16, 2024 16:01:00");
//const currentDate = new Date("April 30, 2024 16:01:00");
//const currentDate = new Date("March 28, 2024 16:01:00");
console.log("Jetzt ist: " + currentDate);
//let unavailableDates = [`${currentDate.getFullYear()}-02-31`,]  // Im Kalender nicht auswählbar machen?
let unavailableDates = [];
const anotherOpeningHours = [
    new Date(currentDate.getFullYear()+1, 0, 1), // Neujahr  Format Monat, Tag --> Januar ist Monat 0; d.h. hier wird aktuell der 01.01. definiert
    new Date(currentDate.getFullYear()+1, 0, 6), // 3 Koenig
    new Date(currentDate.getFullYear(), 3, 3), // Karfreitag
    new Date(currentDate.getFullYear(), 3, 5), // Ostersonntag
    new Date(currentDate.getFullYear(), 3, 6), // Ostermontag
    new Date(currentDate.getFullYear(), 4, 1), // 1. Mai
    new Date(currentDate.getFullYear(), 4, 14), // Christi Himmelfahrt
    new Date(currentDate.getFullYear(), 4, 24), // Pfingstsonntag
    new Date(currentDate.getFullYear(), 4, 25), // Pfingstmontag
    new Date(currentDate.getFullYear(), 5, 4), // Fronleichnam
    new Date(currentDate.getFullYear(), 9, 3), // Tag der dt. Einheit
    new Date(currentDate.getFullYear(), 10, 1), // Allerheiligen
    new Date(currentDate.getFullYear(), 11, 24), // Heiligabend
    new Date(currentDate.getFullYear(), 11, 25), // 1. Weihnachtstag
    new Date(currentDate.getFullYear(), 11, 26), // 2. Weihnachtstag
    new Date(currentDate.getFullYear(), 11, 31), // Silvester
    // Schließtage;
    //				 			 new Date(currentDate.getFullYear(), 2, 31), // Sommerfest
   new Date(currentDate.getFullYear(), 10, 29) // Adventsfeier
  ],
  closedDates = [];

function unavailable(a) {
  return (
    (ymd =
      a.getFullYear() +
      "-" +
      ("0" + (a.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + a.getDate()).slice(-2)),
    (day = new Date(ymd).getDay()),
    0 > $.inArray(ymd, unavailableDates) &&
    0 > $.inArray(days[day], anotherOpeningHours)
      ? [!0, "enabled", ""]
      : [!1, "disabled", ""]
  );
}

function isDateClosed(a, b) {
  a = new Date(a.getFullYear(), a.getMonth(), a.getDate());
  let c = !1;
  for (let d = 0; d < b.length; d++) b[d].getTime() == a.getTime() && (c = !0);
  return c;
}

function isDateWorkday(a) {
  const b = a.getDay();
  return 1 <= b && 5 >= b;
}

function getFirstDayAfterWorkday(a, b, c, d = !1) {
  if (!a) return void console.error("date is null");
  if (!b) return void console.error("map is null");
  let e = d;
  return d && !isDateClosed(addDays(a, 1), c)
    ? addDays(a, 1)
    : isDateWorkday(a) && !isDateHoliday(a, b)
    ? ((e = !0),
      isDateClosed(addDays(a, 1), c)
        ? getFirstDayAfterWorkday(addDays(a, 1), b, c, e)
        : addDays(a, 1))
    : getFirstDayAfterWorkday(addDays(a, 1), b, c, e);
}

function isDateHoliday(a, b) {
  if (!a) return void console.error("dateToCheck is null");
  if (!b) return void console.error("map is null");
  const c = getDateString(a);
  let d = !1;
  return (
    b.forEach(function (a, b) {
      if (c === b) return void (d = !0);
    }),
    d
  );
}

function getDateString(a) {
  let b = 10 > a.getDate() ? "0" + a.getDate() : a.getDate(),
    c = 10 > a.getMonth() + 1 ? "0" + (a.getMonth() + 1) : a.getMonth() + 1,
    d = a.getFullYear();
  return `${d}-${c}-${b}`;
}

function addDays(a, b) {
  if (0 === b) return a;
  const c = new Date(a);
  return c.setUTCDate(c.getUTCDate() + b), c;
}

function calculateDateSpanList(a, b) {
  if (b < a || getDateString(a) === getDateString(b)) return [];
  const c = getDateString(b),
    d = [];
  for (; getDateString(a) !== c; )
    d.push(getDateString(a)), (a = addDays(a, 1));
  return d;
}

function setDatePickerDate(a) {
  $("#datepicker-cart").datepicker("setDate", a);
}

function fetchHolidays(a) {
  return fetch(`https://feiertage-api.de/api/?jahr=${a}&nur_land=BW`)
    .then(function (response) {
      return response.json();
    })
    .then(function (holidays) {
      // Durchlaufe die Feiertage und entferne diejenigen mit einem Hinweis
      Object.keys(holidays).forEach((holiday) => {
        if (holidays[holiday].hinweis) {
          delete holidays[holiday];
        }
      });
      //console.log(holidays);
      return holidays;
    });
}
async function loadHolidays(a) {
  if (11 == a.getMonth() && 16 < a.getDay()) {
    const b = await fetchHolidays(a.getFullYear()),
      c = await fetchHolidays(a.getFullYear() + 1),
      d = createHolidayMap(b),
      e = createHolidayMap(c);
    return (
      e.forEach(function (a, b) {
        d.set(b, a);
      }),
      d
    );
  } else {
    const b = await fetchHolidays(a.getFullYear()),
      c = createHolidayMap(b);
    return c;
  }
}

function createHolidayMap(a) {
  if (!a) return void console.error("holidayJson is not present");
  const b = new Map(),
    c = Object.keys(a);
  for (let d = 0; d < c.length; d++) b.set(a[c[d]].datum, c[d]);
  console.log("createHolidayMap: " + b.toString());
  return b;
}

function calcPickupDate(a, b) {
  if (16 > a.getHours()) {
    const c = getFirstDayAfterWorkday(a, b, closedDates),
      d = calculateDateSpanList(a, c);
    return {
      pickupDate: setHoursZero(c),
      unavailableDates: d,
    };
  } else {
    const c = getFirstDayAfterWorkday(addDays(a, 1), b, closedDates),
      d = calculateDateSpanList(a, c);
    return {
      pickupDate: setHoursZero(c),
      unavailableDates: d,
    };
  }
}

function setHoursZero(a) {
  return a ? (a.setHours(0, 0, 0, 0), a) : void console.error("date is null");
}

function initialize(a) {
  new Promise(async function (b) {
    const c = await loadHolidays(a);
    b(c);
  })
    .then(function (b) {
      return calcPickupDate(a, b);
    })
    .then(function (a) {
      (unavailableDates = unavailableDates.concat(a.unavailableDates)),
        setDatePickerDate(a.pickupDate);
    })
    .catch(function (a) {
      console.error("There  was an error while initializing the datepicker", a);
    });
}
initialize(currentDate);
